import React, { useEffect, useRef, ChangeEvent } from 'react';

// Define the props for the AutoResizeTextarea component
interface AutoResizeTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  value: string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
}

const AutoResizeTextarea: React.FC<AutoResizeTextareaProps> = ({ value, onChange, ...props }) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  // Function to adjust the height of the textarea
  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'; // Reset the height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set the height to match the content
    }
  };

  // Adjust the height on initial render and whenever the value changes
  useEffect(() => {
    adjustHeight();
  }, [value]);

  // Handle change event and adjust the height
  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    adjustHeight();
    onChange(e);
  };

  return (
    <textarea
      {...props}
      ref={textareaRef}
      value={value}
      onChange={handleChange}
      style={{ overflow: 'hidden', resize: 'none' }} // Prevent manual resizing
    />
  );
};

export default AutoResizeTextarea;
